import api from 'services/api'
import {SEND_NOTIFICATION_TO_USER, GET_PUSH_NOTIFICATIONS_LIST} from '../endpoints'

export const getPushNotificationsList = async (body) =>
  await api.post(GET_PUSH_NOTIFICATIONS_LIST, body)

export const sendNotificationToUser = async (values) =>
  await api.post(SEND_NOTIFICATION_TO_USER, values)
